import { useScrollReveal, useCountUp } from '@/hooks/useScrollReveal';

const statsData = [
  { value: 2500, suffix: '+', label: 'Mutlu Müşteri' },
  { value: 10, suffix: '+', label: 'Yıl Tecrübe' },
  { value: 7, suffix: '/24', label: 'Teknik Destek' },
  { value: 98, suffix: '%', label: 'Memnuniyet' },
];

const features = [
  {
    icon: 'ri-award-line',
    title: 'Uzman Teknisyenler',
    desc: 'Sertifikalı ve deneyimli teknisyen kadromuzla her türlü teknik sorununuzu çözüyoruz.',
  },
  {
    icon: 'ri-time-line',
    title: 'Hızlı Servis',
    desc: 'Çoğu tamir işlemini aynı gün teslim ediyoruz. Acil servis seçeneğimiz de mevcuttur.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garanti',
    desc: 'Tüm tamir işlemlerimizde 3 ay garanti veriyoruz. Güvenle bırakın, güvenle alın.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Uygun Fiyat',
    desc: 'Piyasanın en rekabetçi fiyatlarıyla kaliteli hizmet sunuyoruz. Gizli ücret yok.',
  },
];

const StatItem = ({ value, suffix, label, start }: { value: number; suffix: string; label: string; start: boolean }) => {
  const count = useCountUp(value, 1800, start);
  return (
    <div className="text-center">
      <div className="text-2xl font-extrabold text-orange-500">
        {count}{suffix}
      </div>
      <div className="text-xs text-slate-500 mt-0.5">{label}</div>
    </div>
  );
};

const WhyUsSection = () => {
  const { ref: sectionRef, visible } = useScrollReveal(0.1);
  const { ref: imageRef, visible: imageVisible } = useScrollReveal(0.1);
  const { ref: statsRef, visible: statsVisible } = useScrollReveal(0.3);

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left Image */}
          <div
            ref={imageRef}
            className={`relative transition-all duration-1000 ${imageVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`}
          >
            <div className="rounded-2xl overflow-hidden w-full h-[420px]">
              <img
                src="https://public.readdy.ai/ai/img_res/27c268313695ab325c885088b5858a68.jpg"
                alt="Teknik Servis"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Stats overlay */}
            <div
              ref={statsRef}
              className={`absolute -bottom-6 -right-4 md:-right-8 bg-white rounded-xl p-5 grid grid-cols-2 gap-4 w-64 border border-slate-100 transition-all duration-700 delay-300 ${statsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            >
              {statsData.map((stat, i) => (
                <StatItem key={i} value={stat.value} suffix={stat.suffix} label={stat.label} start={statsVisible} />
              ))}
            </div>
          </div>

          {/* Right Content */}
          <div
            ref={sectionRef}
            className={`pt-8 lg:pt-0 transition-all duration-1000 delay-200 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'}`}
          >
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold px-3 py-1 rounded-full mb-4 uppercase tracking-wider">
              Neden Biz?
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 leading-tight">
              Güvenilir Teknik Servis<br />Deneyimi
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              10 yılı aşkın tecrübemizle binlerce müşteriye hizmet verdik. Uzman ekibimiz ve modern ekipmanlarımızla cihazlarınızı en iyi şekilde tamir ediyoruz.
            </p>

            <div className="space-y-5">
              {features.map((f, i) => (
                <div
                  key={i}
                  className={`flex gap-4 items-start group transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                  style={{ transitionDelay: visible ? `${300 + i * 100}ms` : '0ms' }}
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-50 group-hover:bg-orange-500 transition-colors duration-200 flex-shrink-0">
                    <i className={`${f.icon} text-lg text-orange-500 group-hover:text-white transition-colors duration-200`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm mb-1">{f.title}</h4>
                    <p className="text-slate-500 text-sm leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="/iletisim"
              className="inline-flex items-center gap-2 mt-8 bg-slate-900 hover:bg-orange-500 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Hemen İletişime Geç
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
